import { render, staticRenderFns } from "./MovieBlock.vue?vue&type=template&id=1773c667&scoped=true&lang=pug&"
import script from "./MovieBlock.vue?vue&type=script&lang=js&"
export * from "./MovieBlock.vue?vue&type=script&lang=js&"
import style0 from "./MovieBlock.vue?vue&type=style&index=0&id=1773c667&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1773c667",
  null
  
)

export default component.exports